<div (click)="redirect()" class="sip">
	<div class="text">Social Impact Plan</div>
	<div class="trynow"><span>Try now</span></div>
</div>